import { Component, Fragment } from 'react';
import {bool, func, string} from 'react-proptypes';
import {connect} from 'react-redux';
import analytics from 'shared/utility/analytics';
import {Loader} from 'shared/components';
import {dispatchMapper, dispatchWithRequest, SYNC} from 'shared/wizard/actions';
import {shapeInput, shapeOutput, shapeSettings} from '../config';
import InputForm from './InputForm';
import Table from './overviewTable/Table';

class Overview extends Component {
  state = {
    mobileForm: true,
    ltvDropdown: false,
    editRvp: false,
    showContact: false,
  };

  componentDidMount = () => {
    analytics.send('Openen', 'Renteoverzicht');
    const { dispatch, sync, input } = this.props;
    const tempRvp = [...input.frt];
    const tempRvpFindIndex = tempRvp.findIndex(rvp => rvp === input.sorted_frt);
    let tempRvpIndex = tempRvpFindIndex > 0 ? tempRvpFindIndex : 0;

    sync('sorted_frt', tempRvp[tempRvpIndex]);

    if (tempRvpIndex > 0 && window.innerWidth < 780) {
      tempRvp.splice(tempRvpIndex, 1);
      tempRvp.unshift(input.sorted_frt);
      tempRvpIndex = 0;
    }

    dispatch(
      dispatchWithRequest('frt', tempRvp, '/renteoverzicht/calculate/interest-overview', 'overview', result => {
        this.sortTable(result.data, { sorted_frt: tempRvp[tempRvpIndex] });
      })
    );
  };

  updateSendHandler = (property, value) => {
    const { sync, dispatch } = this.props;
    if (property === 'ltv') sync('nhg', false);
    const request = '/renteoverzicht/calculate/interest-overview';
    dispatch({ type: 'BUSY' });
    dispatch(
      dispatchWithRequest(property, value, request, 'overview', result => {
        this.sortTable(result.data);
        sync('selectedLabel', 'S0');
      })
    );
  };

  sortTable = (result, sortQuery) => {
    const { input } = this.props;
    const { sorted_frt } = !sortQuery || typeof sortQuery.sorted_frt === 'undefined' ? this.props.input : sortQuery;
    const { prefer_collaboration } =
      !sortQuery || typeof sortQuery.prefer_collaboration === 'undefined' ? this.props.input : sortQuery;
    const { prefer_auto_risk_class_reduction } =
      !sortQuery || typeof sortQuery.prefer_auto_risk_class_reduction === 'undefined' ? this.props.input : sortQuery;

    let sortedResults = result.sort((a, b) => {
      const interestRateA = a.frts.find(frtObject => frtObject.frt === sorted_frt)?.interest_rate;
      const interestRateB = b.frts.find(frtObject => frtObject.frt === sorted_frt)?.interest_rate;

      // Set selected label as first
      if (a.label_id && a.label_id === input.label_id) {
        return -1;
      }
      // Move empty-value's down
      if (!interestRateA) {
        return 1;
      }
      if (!interestRateB) {
        return -1;
      }
      // Sort by interest-rate
      if (interestRateA < interestRateB) {
        return -1;
      }
      if (interestRateA > interestRateB) {
        return 1;
      }
      // Values are equal
      return 0;
    });

    if (input.selected_provider) {
      sortedResults = sortedResults.filter(
          label => label.mortgage_provider_id === input.selected_provider
      );
    }

    // split sorted results based on preferences
    if (prefer_collaboration || prefer_auto_risk_class_reduction) {
      const reducer = sortedResults.reduce((acc, obj) => {
        let key;
        if (prefer_collaboration && prefer_auto_risk_class_reduction) {
          key = obj.collaboration && obj.has_auto_risk_class_reduction;
        } else if (prefer_collaboration && !prefer_auto_risk_class_reduction) {
          key = obj.collaboration;
        } else if (prefer_auto_risk_class_reduction && !prefer_collaboration) {
          key = obj.has_auto_risk_class_reduction;
        }
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});

      const preferredResults = reducer.true || [];
      sortedResults = reducer.false;

      this.props.dispatch({ type: SYNC, payload: { preferredResults, sortedResults } });
    } else {
      this.props.dispatch({ type: SYNC, payload: { preferredResults: [], sortedResults } });
    }
  };

  ltvDropdownOpener = e => {
    e.preventDefault();
    this.setState(({ ltvDropdown }) => ({ ltvDropdown: !ltvDropdown }));
  };

  switchMobileCustomLtv = resetMarketValue => {
    if (resetMarketValue) this.updateSendHandler('nhg', true);
    this.updateSendHandler('mobileCustomLtv', !this.props.input.mobileCustomLtv);
    this.setState(({ mobileCustomLtv }) => ({ mobileCustomLtv: !mobileCustomLtv }));
  };

  calculateMortageHandler = () => {
    if (
      (this.state.ltvDropdown || this.props.input.mobileCustomLtv) &&
      this.props.input.mortgageValue &&
      this.props.input.houseValue
    ) {
      const value = (this.props.input.mortgageValue / this.props.input.houseValue) * 100;
      this.updateSendHandler('customLtv', value);
      this.setState({ ltvDropdown: false });
      this.updateSendHandler('ltv', value);
    } else {
      this.updateSendHandler('mobileCustomLtv', false);
    }
  };

  changeSorting = (sortKey, sortQuery) => {
    const { sync, output } = this.props;
    sync(sortKey, sortQuery);
    this.sortTable(output.overview.data, { [sortKey]: sortQuery });
    sync('selectedLabel', 'S0');
  };

  render() {
    const { input, output, syncing, sync, settings } = this.props;
    const { overview, preferredResults, sortedResults, errors } = output;
    const { mobileForm } = this.state;
    let products = [];
    if (preferredResults) products = [...preferredResults];
    if (sortedResults) products = [...products, ...sortedResults];

    return (
      <Fragment>
        <InputForm
          mobileFormOpen={mobileForm}
          mobileFormOpener={() => this.setState({ mobileForm: !this.state.mobileForm })}
          ltvDropdown={this.state.ltvDropdown}
          ltvDropdownOpener={this.ltvDropdownOpener}
          input={input}
          errors={errors}
          settings={settings}
          calculateMortageHandler={this.calculateMortageHandler}
          changeSorting={this.changeSorting}
          updateSendHandler={this.updateSendHandler}
          switchMobileCustomLtv={this.switchMobileCustomLtv}
        />
        {mobileForm && (
          <>
            {syncing || (!preferredResults && !sortedResults) ? (
              <Loader />
            ) : (
              <Table
                products={products}
                preferredResults={preferredResults}
                sortedResults={sortedResults}
                overview={overview}
                input={input}
                app={this.props.app}
                framed={this.props.framed}
                sync={sync}
                settings={settings}
                syncing={this.props.syncing}
                output={this.props.output}
                updateSendHandler={this.updateSendHandler}
                changeSorting={this.changeSorting}
                tempRvp={this.state.tempRvp}
                dispatch={this.props.dispatch}
              />
            )}
          </>
        )}
      </Fragment>
    );
  }
}

Overview.propTypes = {
  app: string.isRequired,
  framed: bool.isRequired,
  output: shapeOutput,
  input: shapeInput,
  sync: func.isRequired,
  syncing: bool.isRequired,
  dispatch: func.isRequired,
  settings: shapeSettings.isRequired,
};

Overview.defaultProps = {
  output: null,
  input: null,
};

export default connect(
  state => ({
    app: state.app,
    framed: state.framed,
    output: state.output,
    input: state.input,
    syncing: state.syncing,
    settings: state.settings,
  }),
  dispatchMapper
)(Overview);
